import * as Yup from 'yup'
import { array, object } from 'yup'
import { validatePolish } from 'validate-polish'
import { isSingleCharacterString } from '../../react-components/sale-form/subcomponents/saleFormFunctions'
import { __ } from '@wordpress/i18n'
const postalCodeRegExp = '^([0-9]{2})(-[0-9]{3})?$'
const phoneRegExp = '[0-9]{9}';

Yup.addMethod(Yup.string, 'notSingleCharacterStringValidation', function (errorMessage) {
  let { message } = errorMessage
  return this.test('test-string', message, function (value) {
    const { path, createError } = this
    let errMess = errorMessage;
    if(isSingleCharacterString(value)){
      return  createError({ path, message: errMess })
    }
    return true
  })
})

Yup.addMethod(Yup.string, 'emailValidation', function (errorMessage) {
  const email_REGX = /^([A-Z]*[a-z]*[0-9]*[-_]?)+(?:\+[A-z0-9-_]+)*(?:\.[A-z0-9-_+]+)*@(?:[a-zA-z0-9](?:[a-zA-z0-9-]*[a-zA-z0-9])?\.)+([A-z]{2,})$/
  return this.test('test-nip', errorMessage, function (value) {
    const { path, createError } = this
    if (value) {

      const punycode = require('punycode/')
      let unicodeValue = punycode.toUnicode(value)

      if (unicodeValue !== value) {
        //Jesli wartość to punycode to weryfikujemy czy unicodowa wersja jest zgodna z regexem
        return unicodeValue.search(email_REGX) !== -1 || createError({ path, message: errorMessage })
      }

      return value.search(email_REGX) !== -1 || createError({ path, message: errorMessage })
    } else {
      return true
    }
  })
})

Yup.addMethod(Yup.string, 'nipValidation', function (errorMessage) {
  let { message } = errorMessage
  return this.test('test-nip', message, function (value) {
    const { path, createError } = this
    let errMess = errorMessage;
    if (value) {
      if(value.includes('-') || value.includes(' ')){
        errMess=__('Podaj NIP bez odstępów i znaków specjalnych, np. "-" ', 'strefamanagera');
      }
      return (validatePolish.nip(value) &&  !value.includes('-')) || createError({ path, message: errMess })
    } else {
      return true
    }
  })
})

export const freeLiveMeetingValidation = Yup.object().shape({
  //OSOBA ZAMAWIAJACA
  orderUser_firstName: Yup.string()
    .min(2, __('Minimum 2 znaki', 'strefamanagera'))
    .max(255, __('Maksymalnie 255 znaków', 'strefamanagera'))
    .required(__('* Pole obowiązkowe', 'strefamanagera')),
  orderUser_lastName: Yup.string()
    .min(2, __('Minimum 2 znaki', 'strefamanagera'))
    .max(255, __('Maksymalnie 255 znaków', 'strefamanagera'))
    .required(__('* Pole obowiązkowe', 'strefamanagera')),
  orderUser_email: Yup.string().email(__('E-mail niepoprawny', 'strefamanagera')).required(__('* Pole obowiązkowe', 'strefamanagera')),
  orderUser_phone: Yup.string().required(__('* Pole obowiązkowe', 'strefamanagera')).min(9, __('Podaj 9 cyfr', 'strefamanagera')).matches(phoneRegExp, __('Numer telefonu jest niepoprawny', 'strefamanagera')).notSingleCharacterStringValidation(__('Numer telefonu jest niepoprawny', 'strefamanagera')).max(9, __('Podaj 9 cyfr', 'strefamanagera')),
  agreements:
     Yup.array().of(object().shape({
        rodo: Yup.bool().oneOf([true], __('* Pole obowiązkowe', 'strefamanagera')),
      })),
  nip: Yup.string().when('orderByOrganization', {
    is: true,
    then: Yup.string().nipValidation(__('NIP niepoprawny', 'strefamanagera')).notSingleCharacterStringValidation(__('NIP niepoprawny', 'strefamanagera')).required(__('* Pole obowiązkowe', 'strefamanagera')),
  }),
  organization_name: Yup.string().when('orderByOrganization', {
    is: true,
    then: Yup.string().min(2, __('Minimum 2 znaki', 'strefamanagera')).max(255, __('Maksymalnie 255 znaków', 'strefamanagera')).required(__('* Pole obowiązkowe', 'strefamanagera')),
  }),
})